import { render, staticRenderFns } from "./QuestionnaireFormatPageLocator.vue?vue&type=template&id=d0626a22&scoped=true&"
import script from "./QuestionnaireFormatPageLocator.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireFormatPageLocator.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionnaireFormatPageLocator.vue?vue&type=style&index=0&id=d0626a22&lang=scss&scoped=true&"
import style1 from "./QuestionnaireFormatPageLocator.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0626a22",
  null
  
)

export default component.exports